import { render, staticRenderFns } from "./MenuEducatorsAndPedagogues.vue?vue&type=template&id=6eda5b98&"
import script from "./MenuEducatorsAndPedagogues.vue?vue&type=script&lang=js&"
export * from "./MenuEducatorsAndPedagogues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports